export default function CProjects() {
  return <h2>C Projects</h2>;
}
